import React, { useState, useEffect } from "react";
import {
  Button,
  Input,
  FormControl,
  FormLabel,
  Textarea,
  Checkbox,
  Heading,
  SimpleGrid,
  Box,
  Stack,
  Icon,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Flex,
  Select,
  ModalCloseButton,
  useDisclosure,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Text,
  Td,
} from "@chakra-ui/react";
import {
  FaSync,
  FaPrint,
  FaPlus,
  FaEdit,
  FaTrash,
  FaUser,
  FaEnvelope,
  FaPhone,
  FaHeading,
  FaFileAlt,
  FaCalendarAlt,
  FaRedo,
} from "react-icons/fa";
import axios from "axios"; // Import axios to make API requests
import { Link } from "react-router-dom";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Enquiry = () => {
  const { isOpen, onOpen, onClose } = useDisclosure(); // Modal state management
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [title, setTitle] = useState("");

  const [description, setDescription] = useState("");
  const [enquiryDate, setEnquiryDate] = useState("");
  const [userid, setUserId] = useState(sessionStorage.getItem("user_id")); // Store user_id in state
  const [enquiries, setEnquiries] = useState([]); // State for storing enquiries
  const [editMode, setEditMode] = useState(false); // Flag to switch between add/edit mode
  const [currentEnquiryId, setCurrentEnquiryId] = useState(null); // Stores the ID of the enquiry being edited
  const [repeatedFlag, setRepeatedFlag] = useState(false); // State to handle the checkbox for repeated enquiry
  const toast = useToast();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  // Function to fetch all enquiries
  const fetchEnquiries = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/admin/enquiry/list_all_enquiry.php`
      );
      console.log("enq", response);

      if (response.data.success) {
        setEnquiries(response.data.data); // Set fetched enquiries
      } else {
        toast({
          title: "Error",
          description: response.data.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error fetching enquiries:", error);
      toast({
        title: "Error",
        description: "An error occurred while fetching enquiries.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  // Pagination logic
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = enquiries.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(enquiries.length / rowsPerPage);

  // Handle page change
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleDelete = async (enquiry_id) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/admin/enquiry/delete_enquiry.php`,
        {
          data: {
            pass: userid, // Send the userId (as 'pass')
            enquiry_id, // Send the enquiry ID to be deleted
          },
        }
      );

      if (response.data.success) {
        toast({
          title: "Enquiry deleted successfully.",
          description: response.data.message,
          status: "success",
          duration: 5000,
          isClosable: true,
        });

        // Refresh the list of enquiries after successful deletion
        fetchEnquiries();
      } else {
        toast({
          title: "Error",
          description: response.data.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error deleting enquiry:", error);

      toast({
        title: "Error",
        description: "An error occurred while deleting the enquiry.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  // Fetch enquiries when component mounts
  useEffect(() => {
    fetchEnquiries();
  }, []);

  const handleEdit = (enquiry) => {
    setEditMode(true); // Set edit mode
    setCurrentEnquiryId(enquiry.id); // Store the enquiry ID for editing

    // Populate the form with the selected enquiry data
    setName(enquiry.name);
    setEmail(enquiry.email);
    setPhone(enquiry.mobile);
    setTitle(enquiry.title);
    setDescription(enquiry.description);
    setEnquiryDate(new Date(enquiry.enquiry_date).toISOString().split("T")[0]);
    setRepeatedFlag(enquiry.repeated_flag > 0); // Set the checkbox if enquiry was repeated

    // Open the modal
    onOpen();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const enquiryData = {
      pass: userid, // 'pass' maps to user_id in the PHP code
      name,
      email,
      mobile: phone, // 'mobile' maps to 'phone'
      enquiry_date: enquiryDate,
      title,
      description,
      repeated_flag: repeatedFlag ? 1 : 0, // Send repeated_flag based on checkbox value
    };

    try {
      if (editMode) {
        // If editing, send a PUT request
        enquiryData.enquiry_id = currentEnquiryId; // Add enquiry_id for the PUT request
        const response = await axios.put(
          `${BASE_URL}/admin/enquiry/update_enquiry.php`,
          enquiryData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          toast({
            title: "Enquiry updated successfully.",
            description: response.data.message,
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          setEditMode(false);
        }
      } else {
        // If adding a new enquiry, send a POST request
        const response = await axios.post(
          `${BASE_URL}/admin/enquiry/create_enquiry.php`,
          enquiryData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response.data.success) {
          toast({
            title: "Enquiry submitted.",
            description: response.data.message,
            status: "success",
            duration: 5000,
            isClosable: true,
          });
        }
      }

      // Clear the form after successful submission or update
      setName("");
      setEmail("");
      setPhone("");
      setTitle("");
      setDescription("");
      setEnquiryDate("");
      setRepeatedFlag(false);

      // Close the modal
      onClose();

      // Fetch updated enquiries after submission
      fetchEnquiries();
    } catch (error) {
      console.error("Error submitting enquiry:", error);

      toast({
        title: "Error",
        description: "An error occurred while submitting the enquiry.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
      <div className="teacher-list-container">
        <div className="header">
          <h1 style={{ fontSize: "20px", margin: 0 }}>Enquiry</h1>
          <div
            className="action-buttons"
            style={{ display: "flex", gap: "10px" }}
          >
            <Button
              backgroundColor="teal"
              color="white"
              // fontSize="11px"
              // boxShadow="md"
              onClick={onOpen} // Open the modal
            >
              {!editMode && <FaPlus style={{ marginRight: "5px" }} />}{" "}
              {/* Show plus sign when adding */}
              {editMode ? "Edit Enquiry" : "Add Enquiry"}{" "}
              {/* Conditional button text */}
            </Button>
          </div>
        </div>
        <div className="breadcrumb" style={{ marginBottom: "16px" }}>
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Announcement</span> / <span>Enquiry </span>
        </div>

        <Box marginTop={10} maxWidth="100%">
          <Flex
            justify="space-between"
            align="center"
            className="sb"
            // mb={1}
            p={3}
            // mt={4}
          >
            <Flex align="center">
              <Text mr={2}>Rows Per Page</Text>
              <Select
                width="100px"
                value={rowsPerPage}
                onChange={(e) => setRowsPerPage(Number(e.target.value))}
                borderColor="#E9EDF4"
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </Select>
              {/* <Text ml={2}>Entries</Text> */}
            </Flex>
          </Flex>

          {/* List of Enquiries in a Table */}
          <Box overflowX="auto">
            <Table
              sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}
            >
              <Thead>
                <Tr>
                  <Th>
                    <Box textAlign="center">Name</Box>
                  </Th>
                  <Th>
                    <Box textAlign="center">Title</Box>
                  </Th>
                  <Th>
                    <Box textAlign="center">Enquiry Date</Box>
                  </Th>
                  <Th>
                    <Box textAlign="center">Enquiry Count</Box>
                  </Th>
                  <Th>
                    <Box textAlign="center">Actions</Box>
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {currentData.map((enquiry) => (
                  <Tr key={enquiry.id}>
                    <Td>
                      <Box textAlign="center">{enquiry.name}</Box>
                    </Td>
                    <Td>
                      <Box textAlign="center">{enquiry.title}</Box>
                    </Td>
                    <Td>
                      <Box textAlign="right">
                        {new Date(enquiry.enquiry_date).toLocaleDateString()}
                      </Box>
                    </Td>
                    <Td>
                      <Box textAlign="center">{enquiry.repeated_flag}</Box>
                    </Td>

                    <Td textAlign="center">
                      <Flex justify="center" align="center" gap={2}>
                        <Button
                          onClick={() => handleEdit(enquiry)}
                          colorScheme="teal"
                          size="xs"
                        >
                          <FaEdit />
                        </Button>
                        <Button
                          onClick={() => handleDelete(enquiry.id)}
                          colorScheme="red"
                          size="xs"
                        >
                          <FaTrash />
                        </Button>
                      </Flex>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
          <Flex justify="end" align="center" className="sb2" p={3}>
            <Button
              onClick={() => handlePageChange(currentPage - 1)}
              isDisabled={currentPage === 1}
            >
              Prev
            </Button>
            <Stack direction="row" spacing={2} mx={2}>
              {Array.from({ length: totalPages }, (_, i) => (
                <Button
                  key={i}
                  onClick={() => handlePageChange(i + 1)}
                  colorScheme={currentPage === i + 1 ? "teal" : "gray"}
                >
                  {i + 1}
                </Button>
              ))}
            </Stack>
            <Button
              onClick={() => handlePageChange(currentPage + 1)}
              isDisabled={currentPage === totalPages}
            >
              Next
            </Button>
          </Flex>
        </Box>
        {/* Modal for Adding/Editing Enquiry */}
        <Modal
          isOpen={isOpen}
          onClose={onClose}
          size="lg"
          motionPreset="slideInBottom"
        >
          <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
          <ModalContent
            borderRadius="lg"
            boxShadow="xl"
            bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
            color="gray.700"
            p={6}
            maxW="700px"
            maxH="550px"
            overflowY="auto"
          >
            <ModalHeader
              fontSize="xl"
              fontWeight="bold"
              textAlign="center"
              color="teal.600"
            >
              <Icon as={editMode ? FaEdit : FaPlus} boxSize={5} mr={2} />
              {editMode ? "Edit Enquiry" : "Add Enquiry"}
            </ModalHeader>

            <ModalCloseButton />
            <ModalBody
              overflowY="auto"
              px={4}
              css={{
                "&::-webkit-scrollbar": {
                  width: "6px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "rgba(255, 255, 255, 0.2)",
                  borderRadius: "10px",
                  backdropFilter: "blur(8px)",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "rgba(173, 216, 230, 0.6)",
                  borderRadius: "10px",
                  backdropFilter: "blur(8px)",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "rgba(173, 216, 230, 0.9)",
                },
              }}
            >
              <form onSubmit={handleSubmit}>
                <Stack spacing={4}>
                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                    <FormControl id="name" isRequired>
                      <FormLabel>
                        {" "}
                        <Icon as={FaUser} mr={1} color="teal.500" />
                        Name
                      </FormLabel>
                      <Input
                        type="text"
                        bg="white"
                        _hover={{ borderColor: "teal.300" }}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Enter name"
                      />
                    </FormControl>

                    <FormControl id="email" isRequired>
                      <FormLabel>
                        {" "}
                        <Icon as={FaEnvelope} mr={1} color="teal.500" /> Email
                      </FormLabel>
                      <Input
                        type="email"
                        bg="white"
                        _hover={{ borderColor: "teal.300" }}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter email"
                      />
                    </FormControl>

                    <FormControl id="phone" isRequired>
                      <FormLabel>
                        {" "}
                        <Icon as={FaPhone} mr={1} color="teal.500" /> Phone
                      </FormLabel>
                      <Input
                        type="text"
                        bg="white"
                        _hover={{ borderColor: "teal.300" }}
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        placeholder="Enter phone number"
                      />
                    </FormControl>

                    <FormControl id="title" isRequired>
                      <FormLabel>
                        {" "}
                        <Icon as={FaHeading} mr={1} color="teal.500" /> Title
                      </FormLabel>
                      <Input
                        bg="white"
                        _hover={{ borderColor: "teal.300" }}
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="Enter title"
                      />
                    </FormControl>

                    <FormControl id="description" isRequired>
                      <FormLabel>
                        {" "}
                        <Icon as={FaFileAlt} mr={1} color="teal.500" />{" "}
                        Description
                      </FormLabel>
                      <Textarea
                        value={description}
                        bg="white"
                        _hover={{ borderColor: "teal.300" }}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Enter description"
                      />
                    </FormControl>

                    <FormControl id="enquiry_date" isRequired>
                      <FormLabel>
                        {" "}
                        <Icon as={FaCalendarAlt} mr={1} color="teal.500" />{" "}
                        Enquiry Date
                      </FormLabel>
                      <Input
                        type="date"
                        bg="white"
                        _hover={{ borderColor: "teal.300" }}
                        value={enquiryDate}
                        onChange={(e) => setEnquiryDate(e.target.value)}
                      />
                    </FormControl>

                    <FormControl>
                      <Checkbox
                        isChecked={repeatedFlag}
                        onChange={(e) => setRepeatedFlag(e.target.checked)}
                      >
                        <Icon as={FaRedo} mr={1} color="teal.500" />
                        Is this a repeated enquiry?
                      </Checkbox>
                    </FormControl>
                  </SimpleGrid>
                  <Button
                    bgGradient="linear(to-r, teal.400, teal.600)"
                    color="white"
                    _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
                    type="submit"
                  >
                    {editMode ? "Update Enquiry" : "Add Enquiry"}
                  </Button>
                </Stack>
              </form>
            </ModalBody>
          </ModalContent>
        </Modal>
      </div>
    </div>
  );
};

export default Enquiry;
